var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3767 22.4956L18.7791 3.01456C17.0764 0.148093 12.9258 0.144285 11.2209 3.01456L0.623841 22.4956C-1.11675 25.4246 0.990579 29.1337 4.40208 29.1337H25.5976C29.0062 29.1337 31.1173 25.4276 29.3767 22.4956ZM15 25.6181C14.031 25.6181 13.2422 24.8293 13.2422 23.8603C13.2422 22.8913 14.031 22.1025 15 22.1025C15.969 22.1025 16.7578 22.8913 16.7578 23.8603C16.7578 24.8293 15.969 25.6181 15 25.6181ZM16.7578 18.5868C16.7578 19.5559 15.969 20.3447 15 20.3447C14.031 20.3447 13.2422 19.5559 13.2422 18.5868V9.79778C13.2422 8.82876 14.031 8.03997 15 8.03997C15.969 8.03997 16.7578 8.82876 16.7578 9.79778V18.5868Z",
    fill: "#02020A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature43);
export default __webpack_public_path__ + "static/media/feature-4-3.c30948650e685d60665d188bdde19203.svg";
export { ForwardRef as ReactComponent };